var exports = {
  "VQ": "x234b8571--bf4fa5--ratings",
  "F7": "x234b8571--bf4fa5--ratings__star",
  "Fv": "x234b8571--bf4fa5--ratings__label",
  "Yq": "x234b8571--bf4fa5--reviews",
};

module.exports = exports;
